import React from 'react';
import _ from 'lodash';

import NewEntry from './NewEntry';

import Master from '../../Components/Master';
import Dialog from '../../Components/Dialog';
import Table from '../../Components/Table';
import Loader from '../../Components/Loader';

import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux'
import { doPost, doLoad, doPut, select, doDelete } from '../../Redux/Actions'
import store from '../../Redux';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Toolbar from '@material-ui/core/Toolbar';
import TextField from '@material-ui/core/TextField';

import AddIcon from '@material-ui/icons/Add';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';

import moment from 'moment'
import 'moment/locale/de'
moment.locale("de");


const ENDPOINT = "backup"

const styles = theme => ({

})

const columns = [
    "Backup",
    "Name"
];


class ListObject extends Master {

    state = {
        ...this.state,
        isLoading: true,
        dialogOpen: false,
        newEntry: {},
        route: "/" + ENDPOINT
    }

    componentDidMount() {
        this.props.doLoad()
    }

    doBackup = () => {
        this.props.doBackup()
    }

    render() {

        var { classes } = this.props
        var { newEntry, isLoading, dialogOpen, newEntry } = this.props

        if(isLoading) {
            return (
                <Loader />
            )
        }

        var items = []
        var count = 0
        var page = 0
        
        if(_.has(this.props, ENDPOINT + '.data') && this.props[ENDPOINT].data.length > 0) {
            this.props[ENDPOINT].data.forEach((item) => {
                var name = item.Datname.split("_")
                var newName = ""
                if(name.length > 1){
                    newName = moment.unix(name[1]).format()
                }
                items.push([
                    newName ? newName : item.Datname,
                    item.Datname,
                    item.id
                ])
            })
            count = this.props[ENDPOINT].count
            page = this.props[ENDPOINT].page
        }

        return (
            <div>

                <Table
                    title="Backup"
                    key={ENDPOINT+items.length}
                    data={items}
                    count={count}
                    columns={columns}
                    currentPage={page}
                    populate={this.populate}
                    onDelete={this.deleteAction}
                    options={{
                        selectableRows: false
                    }}
                />

                <Button variant="fab" className="fab" onClick={this.doBackup} color={"primary"}>
                    <AddIcon />
                </Button>

            </div>
        )
    }

}

const mapStateToProps = state => ({
    [ENDPOINT]: state[ENDPOINT],
})

const mapDispatchToProps = (dispatch, ownProps) => ({
    doBackup: (filter) => dispatch(doLoad(ENDPOINT, "api/generic/"+ENDPOINT+"/do", filter)),
    doLoad: (filter) => dispatch(doLoad(ENDPOINT, "api/generic/"+ENDPOINT+"/list", filter)),
    doDelete: (id) => dispatch(doDelete(ENDPOINT, "api/generic/"+ENDPOINT+"/"+id, id)),
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(ListObject));



// WEBPACK FOOTER //
// ./src/Routes/Backup/index.js